<div class="modal-panel-tarefa" *ngIf="concluida">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <mat-icon fontSet="material-symbols-outlined">check_circle</mat-icon>
      </div>
      <div>
        <h2 class="modal-title">Concluir tarefa</h2>
        <p class="modal-subtitle">Confirmação de conclusão</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body modal-body--centered">
    <div class="success-content">
      <img
        [src]="BASE_IMG_URL + 'assets/img-ficha-obra/concluido.png'"
        alt="Sucesso"
        class="success-icon"
      />
      <span class="success-msg">Tarefa concluída com sucesso!</span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-primary" type="button" (click)="continuar()">
      <mat-icon>check</mat-icon>
      Continuar
    </button>
  </div>
</div>
